// extracted by mini-css-extract-plugin
export default {"section":"Fpt4nYgF","container":"GTJ_5sUk","policyWrapper":"LdnemqjH","policyLine":"H_Ju8YQy","lineTitle":"hS_uXSzw","lineText":"trdqPngQ"};